import { RouterItem } from "../interfaces/router-item.interface";

export const routerSidebarItems: RouterItem[] = [
  {
    title: 'SIDEBAR.CUSTOMERS',
    path: '/customers',
    icon: 'users',
  },
  {
    title: 'SIDEBAR.DEACTIVATED_CUSTOMERS',
    path: '/deactivated-customers',
    icon: 'usersCog',
  },
  {
    title: 'SIDEBAR.RULES',
    path: '/rules',
    icon: 'screwdriverWrench',
    groupToAccess: 'admin_tech'
  },
  {
    title: 'SIDEBAR.SRDISCUSSION',
    path: '/srdiscussion',
    icon: 'comment',
    groupToAccess: 'admin_tech'
  },
  {
    title: 'SIDEBAR.FEATURES',
    path: '/featurecomparison',
    icon: 'listTree',
    groupToAccess: 'admin_tech'
  }
];
